import { MainLayout } from "src/apps/commons/layouts";
import { FormContainers } from "src/apps/modules/remyndManual";

const Page = () => <FormContainers isShow={false} />;

Page.Layout = MainLayout;

export default Page;
